/** Lightweight form validators returning an error string or null. */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmail(email: string): string | null {
  if (!email) return 'Email is required';
  if (!EMAIL_RE.test(email)) return 'Enter a valid email address';
  return null;
}

export function validatePassword(password: string): string | null {
  if (!password) return 'Password is required';
  if (password.length < 8) return 'Password must be at least 8 characters';
  return null;
}

export function validateRequired(value: string, label = 'This field'): string | null {
  if (!value || !value.trim()) return `${label} is required`;
  return null;
}

export function validateMatch(a: string, b: string, label = 'Passwords'): string | null {
  if (a !== b) return `${label} do not match`;
  return null;
}
